import { useCallback } from 'react';
import jsPDF from 'jspdf';

export default function useExportPDF() {
  const normalizeMetadata = (data) => {
    if (Array.isArray(data)) return data;
    if (typeof data === 'object' && data !== null) {
      return Object.entries(data).map(([label, value]) => ({
        label,
        value: String(value),
      }));
    }
    return [];
  };

  const exportPDF = useCallback(
    ({ deviceType = '', serialNumber = '', eui = '', signalStatus = '', metadata = [] }) => {
      const doc = new jsPDF();
      const lineHeight = 10;
      let y = 20;

      // Header
      doc.setFontSize(18);
      doc.setFont('helvetica', 'bold');
      doc.text('Commissioning Summary', 20, y);
      y += 6;

      doc.setFontSize(11);
      doc.setFont('helvetica', 'normal');
      const now = new Date().toLocaleString();
      const email = localStorage.getItem('email') || '';
      doc.text(`Generated on: ${now}`, 20, y);
      y += lineHeight;
      if (email) {
        doc.text(`User: ${email}`, 20, y);
        y += lineHeight;
      }

      doc.setDrawColor(160);
      doc.line(20, y, 190, y);
      y += lineHeight;

      doc.setFont('helvetica', 'bold');
      doc.text('Device Information', 20, y);
      y += lineHeight;

      doc.setFont('helvetica', 'normal');
      doc.text(`Device Type: ${deviceType}`, 20, y);
      y += lineHeight;
      if (serialNumber) {
        doc.text(`Serial Number: ${serialNumber}`, 20, y);
        y += lineHeight;
      }
      if (eui) {
        doc.text(`EUI: ${eui}`, 20, y);
        y += lineHeight;
      }
      if (signalStatus) {
        doc.text(`Signal Status: ${signalStatus}`, 20, y);
        y += lineHeight;
      }

      const parsedMetadata = normalizeMetadata(metadata);
      if (parsedMetadata.length > 0) {
        y += 6;
        doc.setFont('helvetica', 'bold');
        doc.text('Metadata', 20, y);
        y += lineHeight;

        doc.setFont('helvetica', 'normal');
        parsedMetadata.forEach(({ label, value }) => {
          doc.text(`${label}:`, 25, y);
          doc.text(value, 90, y);
          y += lineHeight;
        });
      }

      doc.save(`Commissioning-Summary-${serialNumber || deviceType}.pdf`);
    },
    []
  );

  return { exportPDF };
}
